import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { IPersonalRatingRequest } from '../../interfaces';
import { savePersonalRating } from './api';

export function useSavePersonalRating() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const saveRating = async (requests: IPersonalRatingRequest[]): Promise<boolean> => {
    setLoading(true);

    try {
      await savePersonalRating(requests);
      return true;
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, saveRating };
}
